import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function putTeacherAccess(teamId:number, teacherId: number, isActive: boolean): Promise<void> {
    const { apiPutTeacherAccess } = apiConfig.getStaticUrls();

    return postFetch(apiPutTeacherAccess, { teamId, teacherId, isActive });
}
